import React from "react";
import { Link, useParams } from "react-router-dom";
import Button from '@mui/material/Button';
import analyzeIcon from '../../../Assets/Images/Congregation/analyze.svg';
import alignIcon from '../../../Assets/Images/Congregation/align.svg'
import advanceIcon from '../../../Assets/Images/Congregation/advance.svg';
import CongregationTestimonial from '../Testimonial/CongregationTestimonial.jsx';
import ShareIcon from "../../../Assets/Images/Congregation/share-icon.png"

const InviteInfo = (props) => {

  const { id } = useParams();


  return (
    <div className="invite-container">
      <div className="invite-container-spacer">
        <h3>Invite your team to take this same assessment</h3>
        <p>Invite your team to take this assessment with you, and view group and individual results to find where you’re aligned and where you need to align to maximize congregational engagement!</p>
        <div className="invite-reasons">
          <div className="reason">
            <img src={analyzeIcon} alt="insights icon" /><br />
            <div className="height30"></div>
            <span>Assess</span><br />
            Measure your performance in key areas concerning engagement
          </div>

          <div className="reason">
            <img src={alignIcon} alt="alignment icon" /><br />
            <div className="height30"></div>
            <span>Benchmark</span><br />
            Check how you compare with similarly-sized churches
          </div>

          <div className="reason">
            <img src={advanceIcon} alt="direction icon" /><br />
            <div className="height30"></div>
            <span>Calibrate</span><br />
            Align around action based on carefully assessed data
          </div>

        </div>

        <div className="cta-btn">
          <Link to={"/congregation/invite-team/" + id}>
            <Button>INVITE MY TEAM</Button>
          </Link>
        </div>

        {/* <CongregationTestimonial /> */}


      </div>

      {/* <div className="testimonial-invite">
        <p>Invite your team to take this test along with you and begin to align around the vision for your church's mission!</p>
        <div className="cta-btn">
          <Link to={"/invite-team/" + id} target="_blank">
            <Button>INVITE YOUR TEAM</Button>
          </Link>
        </div>
      </div> */}

    </div>
  );
}

export default InviteInfo;
